export const PER_MONTH = '/Monat';
export const PER_KWH = '/kWh';
export const PAGE_SIZE = [50, 100, 150];
export const DEFAULT_CURRENT_INIT_PAGE = 0;
export const MIN_PAGE_SIZE = PAGE_SIZE[0];
export const BillingDataForOrigin = {
  CONTRACT_PAGE: 'CONTRACT_PAGE',
  BILLS_PAGE: 'BILLS_PAGE',
};
// operator billing settings: allowed decimal places for unit prices on bills
export const EINZELPREIS_BILL_DECIMAL_SCALES = [2, 3, 4];
export const DEFAULT_EINZELPREIS_BILL_DECIMAL_SCALE = 2;
// operator communication settings with the defaults used when a value is missing
export const OPERATOR_COMMUNICATION_SETTINGS = [
  {
    name: 'sendEmailToContractUsers',
    label: 'LBLSendEmailToContractUsers',
    defaultValue: true,
  },
  {
    name: 'automaticSendBillEmail',
    label: 'LBLAutomaticSendBillEmail',
    defaultValue: false,
  },
  {
    name: 'technicianSendConnectorFaultReport',
    label: 'LBLTechnicianSendConnectorFaultReport',
    defaultValue: false,
  },
];
